import { useContext } from 'react';
import { AppShellContext, type AppShellContextValue } from '@/components/shell/AppShellContext.ts';

/**
 * Read drawer state + setters from within the AppShell tree. The
 * primary consumer is TopBar's hamburger button; SideNav uses
 * `closeDrawer` to dismiss the mobile sheet on certain interactions.
 *
 * Returns `null` outside an AppShell so callers (tests, isolated
 * harnesses) can render gracefully.
 */
export function useAppShellDrawer(): AppShellContextValue | null {
  return useContext(AppShellContext);
}
